import React from 'react';
import { Box, TextField } from 'vindi-ds-components';

const Field = ({ title, handleChange }) => (
  <Box css={{ marginBottom: '0.5em', width: '100%' }}>
    <TextField
      label={title}
      id={title}
      size='medium'
      placeholder={title}
      onChange={(e) => handleChange(e.target.value)}
    />
  </Box>
);

export default Field;
